import {createContext, useContext} from "react";

const sectionNameContext = createContext("");

export const SectionNameProvider = sectionNameContext.Provider;

export function useSectionName() {
  return useContext(sectionNameContext);
}
